import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { ModalDialog } from 'axway-react-ui';
import FieldEditorDialogContent from './FieldEditorDialogContent';

const customEditorFormats = [ 'javascript', 'mustache', 'xml' ];

class FieldEditorDialog extends ModalDialog.Content {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.onChange = this.onChange.bind(this);
		this.state = {
			value: props.value
		};
	}

	componentWillReceiveProps(newProps) {
		this.setState({
			value: newProps.value
		});
	}

	onChange(value) {
		this.setState({ value });
	}

	render() {
		const { name, json, schema, show, hideSchema } = this.props;
		const { value } = this.state;

		let mode;
		if (json) {
			mode = 'json';
		} else if (customEditorFormats.includes(schema.format)) {
			mode = schema.format;
		} else {
			mode = 'text/plain';
		}

		const newSchema = JSON.parse(JSON.stringify(schema));
		// description is in the header now
		const description = newSchema.description;
		delete newSchema.description;

		// remove any "extraneous" properties
		const options = newSchema.options || {};
		delete newSchema.options;
		delete newSchema.group;

		return (
			<ModalDialog
				title={this.intl.formatMsg('Edit {name}', { name })}
				subtitle={description}
				dialogClassName="nodeconfigfield-dialog"
				backdrop="static"
				okayText={this.intl.formatMsg('Okay')}
				closeText={this.intl.formatMsg('Cancel')}
				show={show}
				onClose={this.props.onClose}
				onOkay={() => this.props.onOkay(value)}
				validateOnOkay={false}
			>
				<FieldEditorDialogContent
					name={name}
					schema={newSchema}
					multilineWrapper={options.multilineWrapper}
					value={value}
					onChange={this.onChange}
					mode={mode}
					hideSchema={hideSchema}
				/>
			</ModalDialog>
		);
	}
}

FieldEditorDialog.propTypes = {
	name: PropTypes.string.isRequired,
	schema: PropTypes.object.isRequired,
	hideSchema: PropTypes.bool,
	value: PropTypes.string,
	json: PropTypes.bool,
	show: PropTypes.bool,
	onOkay: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired
};

FieldEditorDialog.defaultProps = {
	hideSchema: false
};

FieldEditorDialog.customEditorFormats = customEditorFormats;

export default injectIntl(FieldEditorDialog);
